import React from 'react';
import { Section } from '../ui/Section';
import { AlertTriangle } from 'lucide-react';
export function SabotageSection() {
  return <Section data-id="element-165">
      <div className="max-w-4xl mx-auto" data-id="element-166">
        <div className="text-center mb-12" data-id="element-167">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-danger/10 mb-6" data-id="element-168">
            <AlertTriangle className="w-8 h-8 text-brand-danger" data-id="element-169" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white" data-id="element-170">
            El Sabotaje Silencioso Que Está{' '}
            <span className="text-brand-danger" data-id="element-171">Apagando Tu Virilidad</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-172">
          <div className="space-y-6 text-gray-300 text-lg" data-id="element-173">
            <p data-id="element-174">
              El estilo de vida en Estados Unidos está diseñado para destruirte
              como hombre. No es una exageración.
            </p>
            <p data-id="element-175">
              El largo trayecto al trabajo, la comida ultra-procesada llena de
              estrógenos ocultos, la falta de sueño real y los micro-estresores
              diarios actúan como un{' '}
              <strong className="text-white" data-id="element-176">sabotaje silencioso</strong>.
            </p>
            <p data-id="element-177">
              Todo esto bloquea tu llave maestra: tu{' '}
              <strong className="text-brand-gold" data-id="element-178">
                TSA (Testosterona Sexual Activa)
              </strong>
              .
            </p>
          </div>

          <div className="bg-brand-card p-8 rounded-xl border border-brand-gold/20 shadow-[0_0_30px_rgba(0,0,0,0.5)]" data-id="element-179">
            <h3 className="text-2xl font-bold text-brand-lightGold mb-4 font-serif" data-id="element-180">
              ¿Qué es la TSA?
            </h3>
            <p className="text-gray-300 mb-4" data-id="element-181">
              No se trata solo de tus "niveles de testosterona" en un examen
              médico. Los médicos te dirán que estás "en el rango normal".
            </p>
            <p className="text-gray-300" data-id="element-182">
              La TSA es la testosterona{' '}
              <strong className="text-white" data-id="element-183">libre y activa</strong> que tu
              cuerpo realmente puede usar para generar deseo, flujo sanguíneo y
              erecciones de acero. Y el entorno moderno la está secuestrando.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}